// extracted by mini-css-extract-plugin
module.exports = {"shareContainer":"Share_shareContainer__PtuLd","shareLinkWrapper":"Share_shareLinkWrapper__1Pkgm","shareLink":"Share_shareLink__2oThd"};